import { render, staticRenderFns } from "./AssetsRoster.vue?vue&type=template&id=0a8aecac"
import script from "./AssetsRoster.vue?vue&type=script&lang=js"
export * from "./AssetsRoster.vue?vue&type=script&lang=js"
import style0 from "./AssetsRoster.vue?vue&type=style&index=0&id=0a8aecac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports